import { Link, useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-xl">Esta página no existe o la URL está mal escrita.</p>

      <div className="flex gap-3">
        <button onClick={() => navigate(-1)} className="px-4 py-2 rounded bg-gray-200">
          Volver
        </button>

        <Link to="/" className="px-4 py-2 rounded bg-blue-600 text-white">
          Ir al inicio
        </Link>
      </div>
    </div>
  );
}
